import React from "react";
import { DropdownItem } from "reactstrap";
import { FormattedMessage } from "react-intl";

type Props = {
  handleAction: () => void;
  iconClassName?: string;
  labelId: string;
};

export default function ActionDropdownItem(props: Props) {
  return (
    <DropdownItem onClick={props.handleAction} className="cursor-pointer">
      <i className={props.iconClassName}></i>
      <span>
        <FormattedMessage id={props.labelId} />
      </span>
    </DropdownItem>
  );
}
